// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bie_jk","CommentListPlaceholder--Legacy":"ih_b bie_rc bie_wq"};